import axios from "axios";
import Cookies from "js-cookie";
import {ACCESS_TOKEN_KEY, COOKIES_COMPANY_ID} from "../helper/constants";

const API_URL = process.env.REACT_APP_API_URL;

// Create an instance of Axios with the base URL
const apiService = axios.create({baseURL: API_URL});

// Create a function to set the authorization header
function setAuthHeader(token: string) {
    if (token) {
        apiService.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
        delete apiService.defaults.headers.common["Authorization"];
    }
}

function getAuthValues(): {companyId?: string, token?: string} {
    const token = Cookies.get(`${ACCESS_TOKEN_KEY}`);
    const companyId = Cookies.get(`${COOKIES_COMPANY_ID}`);
    return {companyId, token};
}

export {apiService, setAuthHeader, getAuthValues};
